@file:OptIn(InternalResourceApi::class)

package event_management_system.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/event_management_system.composeapp.generated.resources/"

@delegate:ResourceContentHash(-30_981_528)
internal val Res.string.action_back: StringResource by lazy {
      StringResource("string:action_back", "action_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 31),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.action_cancel: StringResource by lazy {
      StringResource("string:action_cancel", "action_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42, 29),
      ))
    }

@delegate:ResourceContentHash(-1_970_235_291)
internal val Res.string.action_change_status: StringResource by lazy {
      StringResource("string:action_change_status", "action_change_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72, 48),
      ))
    }

@delegate:ResourceContentHash(-327_200_099)
internal val Res.string.action_create: StringResource by lazy {
      StringResource("string:action_create", "action_create", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165, 29),
      ))
    }

@delegate:ResourceContentHash(1_307_884_781)
internal val Res.string.action_create_event: StringResource by lazy {
      StringResource("string:action_create_event", "action_create_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 121, 43),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.action_delete: StringResource by lazy {
      StringResource("string:action_delete", "action_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195, 29),
      ))
    }

@delegate:ResourceContentHash(-760_963_424)
internal val Res.string.action_edit: StringResource by lazy {
      StringResource("string:action_edit", "action_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 27),
      ))
    }

@delegate:ResourceContentHash(-1_360_447_829)
internal val Res.string.action_edit_event: StringResource by lazy {
      StringResource("string:action_edit_event", "action_edit_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 225, 41),
      ))
    }

@delegate:ResourceContentHash(-594_574_083)
internal val Res.string.action_forgot_password: StringResource by lazy {
      StringResource("string:action_forgot_password", "action_forgot_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 295, 54),
      ))
    }

@delegate:ResourceContentHash(406_147_690)
internal val Res.string.action_hide: StringResource by lazy {
      StringResource("string:action_hide", "action_hide", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 350, 27),
      ))
    }

@delegate:ResourceContentHash(-2_131_873_922)
internal val Res.string.action_list_view: StringResource by lazy {
      StringResource("string:action_list_view", "action_list_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 378, 32),
      ))
    }

@delegate:ResourceContentHash(2_552_198)
internal val Res.string.action_ok: StringResource by lazy {
      StringResource("string:action_ok", "action_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 411, 21),
      ))
    }

@delegate:ResourceContentHash(1_223_497_630)
internal val Res.string.action_pick_time: StringResource by lazy {
      StringResource("string:action_pick_time", "action_pick_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 433, 36),
      ))
    }

@delegate:ResourceContentHash(-484_201_967)
internal val Res.string.action_print: StringResource by lazy {
      StringResource("string:action_print", "action_print", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 470, 28),
      ))
    }

@delegate:ResourceContentHash(462_934_863)
internal val Res.string.action_send_reset_link: StringResource by lazy {
      StringResource("string:action_send_reset_link", "action_send_reset_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 499, 50),
      ))
    }

@delegate:ResourceContentHash(43_456_388)
internal val Res.string.action_send_to_host: StringResource by lazy {
      StringResource("string:action_send_to_host", "action_send_to_host", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 550, 43),
      ))
    }

@delegate:ResourceContentHash(1_660_357)
internal val Res.string.action_settings: StringResource by lazy {
      StringResource("string:action_settings", "action_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 594, 27),
      ))
    }

@delegate:ResourceContentHash(-1_964_930_498)
internal val Res.string.action_show: StringResource by lazy {
      StringResource("string:action_show", "action_show", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 622, 27),
      ))
    }

@delegate:ResourceContentHash(1_384_936_371)
internal val Res.string.action_sign_in: StringResource by lazy {
      StringResource("string:action_sign_in", "action_sign_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 650, 34),
      ))
    }

@delegate:ResourceContentHash(1_390_523_284)
internal val Res.string.action_sign_out: StringResource by lazy {
      StringResource("string:action_sign_out", "action_sign_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 685, 35),
      ))
    }

@delegate:ResourceContentHash(-1_955_141_916)
internal val Res.string.action_update: StringResource by lazy {
      StringResource("string:action_update", "action_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 721, 29),
      ))
    }

@delegate:ResourceContentHash(-485_955_210)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 751, 36),
      ))
    }

@delegate:ResourceContentHash(1_269_111_543)
internal val Res.string.app_version: StringResource by lazy {
      StringResource("string:app_version", "app_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 788, 39),
      ))
    }

@delegate:ResourceContentHash(1_482_108_474)
internal val Res.string.dialog_title_delete_event: StringResource by lazy {
      StringResource("string:dialog_title_delete_event", "dialog_title_delete_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 828, 49),
      ))
    }

@delegate:ResourceContentHash(281_574_811)
internal val Res.string.dialog_title_email_sent: StringResource by lazy {
      StringResource("string:dialog_title_email_sent", "dialog_title_email_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 878, 47),
      ))
    }

@delegate:ResourceContentHash(1_211_502_670)
internal val Res.string.dialog_title_reset_password: StringResource by lazy {
      StringResource("string:dialog_title_reset_password", "dialog_title_reset_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 926, 55),
      ))
    }

@delegate:ResourceContentHash(-1_284_832_191)
internal val Res.string.dialog_title_select_time: StringResource by lazy {
      StringResource("string:dialog_title_select_time", "dialog_title_select_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 982, 56),
      ))
    }

@delegate:ResourceContentHash(600_056_082)
internal val Res.string.empty_msg_adjust_filters: StringResource by lazy {
      StringResource("string:empty_msg_adjust_filters", "empty_msg_adjust_filters", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1039, 68),
      ))
    }

@delegate:ResourceContentHash(1_771_075_939)
internal val Res.string.empty_msg_no_events: StringResource by lazy {
      StringResource("string:empty_msg_no_events", "empty_msg_no_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1108, 79),
      ))
    }

@delegate:ResourceContentHash(1_888_422_824)
internal val Res.string.empty_msg_no_locations: StringResource by lazy {
      StringResource("string:empty_msg_no_locations", "empty_msg_no_locations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1188, 106),
      ))
    }

@delegate:ResourceContentHash(-2_009_351_339)
internal val Res.string.empty_title_no_events: StringResource by lazy {
      StringResource("string:empty_title_no_events", "empty_title_no_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1295, 49),
      ))
    }

@delegate:ResourceContentHash(1_223_969_439)
internal val Res.string.empty_title_no_locations: StringResource by lazy {
      StringResource("string:empty_title_no_locations", "empty_title_no_locations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1345, 60),
      ))
    }

@delegate:ResourceContentHash(2_500_513)
internal val Res.string.filter_all: StringResource by lazy {
      StringResource("string:filter_all", "filter_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1406, 22),
      ))
    }

@delegate:ResourceContentHash(1_976_862_215)
internal val Res.string.filter_confirmed: StringResource by lazy {
      StringResource("string:filter_confirmed", "filter_confirmed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1429, 36),
      ))
    }

@delegate:ResourceContentHash(-1_656_275_420)
internal val Res.string.filter_pending: StringResource by lazy {
      StringResource("string:filter_pending", "filter_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1466, 34),
      ))
    }

@delegate:ResourceContentHash(1_803_126_494)
internal val Res.string.hint_search_events: StringResource by lazy {
      StringResource("string:hint_search_events", "hint_search_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1501, 50),
      ))
    }

@delegate:ResourceContentHash(1_434_399_631)
internal val Res.string.label_caterer: StringResource by lazy {
      StringResource("string:label_caterer", "label_caterer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1602, 33),
      ))
    }

@delegate:ResourceContentHash(1_314_365_214)
internal val Res.string.label_caterer_contact: StringResource by lazy {
      StringResource("string:label_caterer_contact", "label_caterer_contact", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1552, 49),
      ))
    }

@delegate:ResourceContentHash(-1_688_165_153)
internal val Res.string.label_cost: StringResource by lazy {
      StringResource("string:label_cost", "label_cost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1669, 26),
      ))
    }

@delegate:ResourceContentHash(1_998_726_922)
internal val Res.string.label_cost_value: StringResource by lazy {
      StringResource("string:label_cost_value", "label_cost_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1636, 32),
      ))
    }

@delegate:ResourceContentHash(1_898_414_654)
internal val Res.string.label_customer_name: StringResource by lazy {
      StringResource("string:label_customer_name", "label_customer_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1696, 47),
      ))
    }

@delegate:ResourceContentHash(1_922_858_908)
internal val Res.string.label_date_time: StringResource by lazy {
      StringResource("string:label_date_time", "label_date_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1744, 39),
      ))
    }

@delegate:ResourceContentHash(-1_739_334_970)
internal val Res.string.label_deposit: StringResource by lazy {
      StringResource("string:label_deposit", "label_deposit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1841, 33),
      ))
    }

@delegate:ResourceContentHash(-1_348_272_056)
internal val Res.string.label_deposit_dollar: StringResource by lazy {
      StringResource("string:label_deposit_dollar", "label_deposit_dollar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1784, 56),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.label_email: StringResource by lazy {
      StringResource("string:label_email", "label_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1912, 27),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.label_email_required: StringResource by lazy {
      StringResource("string:label_email_required", "label_email_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1875, 36),
      ))
    }

@delegate:ResourceContentHash(-1_539_891_811)
internal val Res.string.label_event_cost: StringResource by lazy {
      StringResource("string:label_event_cost", "label_event_cost", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1940, 72),
      ))
    }

@delegate:ResourceContentHash(1_991_072_976)
internal val Res.string.label_event_date: StringResource by lazy {
      StringResource("string:label_event_date", "label_event_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2013, 40),
      ))
    }

@delegate:ResourceContentHash(1_269_723_029)
internal val Res.string.label_event_end_time: StringResource by lazy {
      StringResource("string:label_event_end_time", "label_event_end_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 64),
      ))
    }

@delegate:ResourceContentHash(914_611_438)
internal val Res.string.label_event_purpose: StringResource by lazy {
      StringResource("string:label_event_purpose", "label_event_purpose", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2119, 59),
      ))
    }

@delegate:ResourceContentHash(-1_327_640_074)
internal val Res.string.label_event_time: StringResource by lazy {
      StringResource("string:label_event_time", "label_event_time", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2179, 60),
      ))
    }

@delegate:ResourceContentHash(773_404_126)
internal val Res.string.label_guest_count: StringResource by lazy {
      StringResource("string:label_guest_count", "label_guest_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2240, 49),
      ))
    }

@delegate:ResourceContentHash(1_759_422_415)
internal val Res.string.label_guests: StringResource by lazy {
      StringResource("string:label_guests", "label_guests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2333, 28),
      ))
    }

@delegate:ResourceContentHash(-969_668_624)
internal val Res.string.label_guests_count: StringResource by lazy {
      StringResource("string:label_guests_count", "label_guests_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2290, 42),
      ))
    }

@delegate:ResourceContentHash(2_031_742_682)
internal val Res.string.label_location: StringResource by lazy {
      StringResource("string:label_location", "label_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2452, 34),
      ))
    }

@delegate:ResourceContentHash(2_031_742_774)
internal val Res.string.label_locations: StringResource by lazy {
      StringResource("string:label_locations", "label_locations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2416, 35),
      ))
    }

@delegate:ResourceContentHash(1_659_390_624)
internal val Res.string.label_locations_count: StringResource by lazy {
      StringResource("string:label_locations_count", "label_locations_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2362, 53),
      ))
    }

@delegate:ResourceContentHash(-207_682)
internal val Res.string.label_notes: StringResource by lazy {
      StringResource("string:label_notes", "label_notes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2487, 27),
      ))
    }

@delegate:ResourceContentHash(-1_252_028_226)
internal val Res.string.label_password: StringResource by lazy {
      StringResource("string:label_password", "label_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2515, 34),
      ))
    }

@delegate:ResourceContentHash(-507_290_829)
internal val Res.string.label_phone: StringResource by lazy {
      StringResource("string:label_phone", "label_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2587, 27),
      ))
    }

@delegate:ResourceContentHash(-507_290_829)
internal val Res.string.label_phone_required: StringResource by lazy {
      StringResource("string:label_phone_required", "label_phone_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2550, 36),
      ))
    }

@delegate:ResourceContentHash(156_649_114)
internal val Res.string.label_post_event_notes: StringResource by lazy {
      StringResource("string:label_post_event_notes", "label_post_event_notes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2615, 54),
      ))
    }

@delegate:ResourceContentHash(647_333_716)
internal val Res.string.label_purpose: StringResource by lazy {
      StringResource("string:label_purpose", "label_purpose", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2670, 45),
      ))
    }

@delegate:ResourceContentHash(1_804_471_337)
internal val Res.string.label_role: StringResource by lazy {
      StringResource("string:label_role", "label_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2716, 26),
      ))
    }

@delegate:ResourceContentHash(-736_397_784)
internal val Res.string.label_select_location: StringResource by lazy {
      StringResource("string:label_select_location", "label_select_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2743, 49),
      ))
    }

@delegate:ResourceContentHash(-1_831_015_332)
internal val Res.string.login_subtitle: StringResource by lazy {
      StringResource("string:login_subtitle", "login_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2793, 50),
      ))
    }

@delegate:ResourceContentHash(-777_777_220)
internal val Res.string.msg_delete_confirm: StringResource by lazy {
      StringResource("string:msg_delete_confirm", "msg_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2844, 126),
      ))
    }

@delegate:ResourceContentHash(-1_103_279_900)
internal val Res.string.msg_reset_email_prompt: StringResource by lazy {
      StringResource("string:msg_reset_email_prompt", "msg_reset_email_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2971, 130),
      ))
    }

@delegate:ResourceContentHash(2_079_944_208)
internal val Res.string.msg_reset_email_sent: StringResource by lazy {
      StringResource("string:msg_reset_email_sent", "msg_reset_email_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3102, 108),
      ))
    }

@delegate:ResourceContentHash(-895_916_428)
internal val Res.string.screen_title_calendar: StringResource by lazy {
      StringResource("string:screen_title_calendar", "screen_title_calendar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3211, 41),
      ))
    }

@delegate:ResourceContentHash(-1_360_447_829)
internal val Res.string.screen_title_edit_event: StringResource by lazy {
      StringResource("string:screen_title_edit_event", "screen_title_edit_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3253, 47),
      ))
    }

@delegate:ResourceContentHash(-511_099_166)
internal val Res.string.screen_title_event_details: StringResource by lazy {
      StringResource("string:screen_title_event_details", "screen_title_event_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3301, 54),
      ))
    }

@delegate:ResourceContentHash(351_863_756)
internal val Res.string.screen_title_events: StringResource by lazy {
      StringResource("string:screen_title_events", "screen_title_events", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3356, 35),
      ))
    }

@delegate:ResourceContentHash(-51_915_706)
internal val Res.string.screen_title_new_event: StringResource by lazy {
      StringResource("string:screen_title_new_event", "screen_title_new_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3392, 42),
      ))
    }

@delegate:ResourceContentHash(2_128_440_428)
internal val Res.string.screen_title_settings: StringResource by lazy {
      StringResource("string:screen_title_settings", "screen_title_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3435, 41),
      ))
    }

@delegate:ResourceContentHash(1_567_724_178)
internal val Res.string.section_about: StringResource by lazy {
      StringResource("string:section_about", "section_about", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3477, 29),
      ))
    }

@delegate:ResourceContentHash(-1_022_005_265)
internal val Res.string.section_account: StringResource by lazy {
      StringResource("string:section_account", "section_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3507, 35),
      ))
    }

@delegate:ResourceContentHash(-895_886_150)
internal val Res.string.section_additional_info: StringResource by lazy {
      StringResource("string:section_additional_info", "section_additional_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3543, 63),
      ))
    }

@delegate:ResourceContentHash(-2_054_069_951)
internal val Res.string.section_customer_contact: StringResource by lazy {
      StringResource("string:section_customer_contact", "section_customer_contact", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3607, 56),
      ))
    }

@delegate:ResourceContentHash(-818_113_107)
internal val Res.string.section_customer_info: StringResource by lazy {
      StringResource("string:section_customer_info", "section_customer_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3664, 57),
      ))
    }

@delegate:ResourceContentHash(-511_099_166)
internal val Res.string.section_event_details: StringResource by lazy {
      StringResource("string:section_event_details", "section_event_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3722, 49),
      ))
    }

@delegate:ResourceContentHash(-908_920_345)
internal val Res.string.section_event_info: StringResource by lazy {
      StringResource("string:section_event_info", "section_event_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3772, 50),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_back", Res.string.action_back)
  map.put("action_cancel", Res.string.action_cancel)
  map.put("action_change_status", Res.string.action_change_status)
  map.put("action_create", Res.string.action_create)
  map.put("action_create_event", Res.string.action_create_event)
  map.put("action_delete", Res.string.action_delete)
  map.put("action_edit", Res.string.action_edit)
  map.put("action_edit_event", Res.string.action_edit_event)
  map.put("action_forgot_password", Res.string.action_forgot_password)
  map.put("action_hide", Res.string.action_hide)
  map.put("action_list_view", Res.string.action_list_view)
  map.put("action_ok", Res.string.action_ok)
  map.put("action_pick_time", Res.string.action_pick_time)
  map.put("action_print", Res.string.action_print)
  map.put("action_send_reset_link", Res.string.action_send_reset_link)
  map.put("action_send_to_host", Res.string.action_send_to_host)
  map.put("action_settings", Res.string.action_settings)
  map.put("action_show", Res.string.action_show)
  map.put("action_sign_in", Res.string.action_sign_in)
  map.put("action_sign_out", Res.string.action_sign_out)
  map.put("action_update", Res.string.action_update)
  map.put("app_name", Res.string.app_name)
  map.put("app_version", Res.string.app_version)
  map.put("dialog_title_delete_event", Res.string.dialog_title_delete_event)
  map.put("dialog_title_email_sent", Res.string.dialog_title_email_sent)
  map.put("dialog_title_reset_password", Res.string.dialog_title_reset_password)
  map.put("dialog_title_select_time", Res.string.dialog_title_select_time)
  map.put("empty_msg_adjust_filters", Res.string.empty_msg_adjust_filters)
  map.put("empty_msg_no_events", Res.string.empty_msg_no_events)
  map.put("empty_msg_no_locations", Res.string.empty_msg_no_locations)
  map.put("empty_title_no_events", Res.string.empty_title_no_events)
  map.put("empty_title_no_locations", Res.string.empty_title_no_locations)
  map.put("filter_all", Res.string.filter_all)
  map.put("filter_confirmed", Res.string.filter_confirmed)
  map.put("filter_pending", Res.string.filter_pending)
  map.put("hint_search_events", Res.string.hint_search_events)
  map.put("label_caterer", Res.string.label_caterer)
  map.put("label_caterer_contact", Res.string.label_caterer_contact)
  map.put("label_cost", Res.string.label_cost)
  map.put("label_cost_value", Res.string.label_cost_value)
  map.put("label_customer_name", Res.string.label_customer_name)
  map.put("label_date_time", Res.string.label_date_time)
  map.put("label_deposit", Res.string.label_deposit)
  map.put("label_deposit_dollar", Res.string.label_deposit_dollar)
  map.put("label_email", Res.string.label_email)
  map.put("label_email_required", Res.string.label_email_required)
  map.put("label_event_cost", Res.string.label_event_cost)
  map.put("label_event_date", Res.string.label_event_date)
  map.put("label_event_end_time", Res.string.label_event_end_time)
  map.put("label_event_purpose", Res.string.label_event_purpose)
  map.put("label_event_time", Res.string.label_event_time)
  map.put("label_guest_count", Res.string.label_guest_count)
  map.put("label_guests", Res.string.label_guests)
  map.put("label_guests_count", Res.string.label_guests_count)
  map.put("label_location", Res.string.label_location)
  map.put("label_locations", Res.string.label_locations)
  map.put("label_locations_count", Res.string.label_locations_count)
  map.put("label_notes", Res.string.label_notes)
  map.put("label_password", Res.string.label_password)
  map.put("label_phone", Res.string.label_phone)
  map.put("label_phone_required", Res.string.label_phone_required)
  map.put("label_post_event_notes", Res.string.label_post_event_notes)
  map.put("label_purpose", Res.string.label_purpose)
  map.put("label_role", Res.string.label_role)
  map.put("label_select_location", Res.string.label_select_location)
  map.put("login_subtitle", Res.string.login_subtitle)
  map.put("msg_delete_confirm", Res.string.msg_delete_confirm)
  map.put("msg_reset_email_prompt", Res.string.msg_reset_email_prompt)
  map.put("msg_reset_email_sent", Res.string.msg_reset_email_sent)
  map.put("screen_title_calendar", Res.string.screen_title_calendar)
  map.put("screen_title_edit_event", Res.string.screen_title_edit_event)
  map.put("screen_title_event_details", Res.string.screen_title_event_details)
  map.put("screen_title_events", Res.string.screen_title_events)
  map.put("screen_title_new_event", Res.string.screen_title_new_event)
  map.put("screen_title_settings", Res.string.screen_title_settings)
  map.put("section_about", Res.string.section_about)
  map.put("section_account", Res.string.section_account)
  map.put("section_additional_info", Res.string.section_additional_info)
  map.put("section_customer_contact", Res.string.section_customer_contact)
  map.put("section_customer_info", Res.string.section_customer_info)
  map.put("section_event_details", Res.string.section_event_details)
  map.put("section_event_info", Res.string.section_event_info)
}
